import { render, staticRenderFns } from "./changeOrganisation.vue?vue&type=template&id=3aa65b14&"
import script from "./changeOrganisation.vue?vue&type=script&lang=js&"
export * from "./changeOrganisation.vue?vue&type=script&lang=js&"
import style0 from "./changeOrganisation.vue?vue&type=style&index=0&id=3aa65b14&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports